import { Popconfirm } from "antd";
import React from "react";

type CustomPopConfirmType = {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  okText?: string;
  cancelText?: string;
  children?: React.ReactNode;
};

export const CustomPopConfirm = ({
  isOpen,
  onClose,
  onConfirm,
  cancelText,
  children,
  okText,
  title,
}: CustomPopConfirmType) => {
  return (
    <Popconfirm
      title={title}
      open={isOpen}
      okText={okText ?? "Oui"}
      cancelText={cancelText ?? "Non"}
      onCancel={onClose}
      onConfirm={onConfirm}
    >
      {children}
    </Popconfirm>
  );
};
